export default "__VITE_ASSET__BP8ybuL7__"